import { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ImageElement } from "components";
import {
  Button,
  Col,
  Container,
  Nav,
  OverlayTrigger,
  Row,
  Spinner,
  Tooltip,
  Modal,
  Form,
  Alert,
} from "react-bootstrap";

import { BROKER_ENDPOINT } from "apiEndpoints";
import refreshIcon from "assets/images/refresh.svg";
import userRouteMap from "routes/User/userRouteMap";
import { commonService } from "services/common.service";
import ReactPWA from "utils/ReactPWA";
import socketEventManager from "socket/socketEvents";
import { toast } from 'react-hot-toast';

// import { Persistor } from "store";

function Landing() {
  const navigate = useNavigate();
  const [state, setState] = useState(() => {
    // sync private mode from local storage to state
    const localValue = localStorage.getItem("privateMode");
    return {
      isLoading: true,
      lists: [],
      showModal: false,
      privateMode: localValue === "true" // convert string to boolean
    };
  });

  // Start Showing modal and form state
  const [showFormModal, setShowFormModal] = useState(false);
  const [showing, setShowing] = useState(false);
  // Update form state to include all required fields
  const [form, setForm] = useState({ firstName: "", lastName: "", email: "", phone: "", notes: "" });
  const [formError, setFormError] = useState({});
  const [apiStatus, setApiStatus] = useState({ success: null, message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);



  const holdTimer = useRef(null);
  // handleMouseEnter: triggers modal after holding for 2 seconds
  const handleMouseEnter = () => {
    holdTimer.current = setTimeout(() => {
      setState(prev => ({
        ...prev,
        showModal: true
      }));
      console.log("done")
    }, 2000); // 2.5 seconds hold
  };

  // On hover end before 2 seconds
  const handleMouseLeave = () => {
    clearTimeout(holdTimer.current);
  };

// handleToggleChange: toggles private mode state
  const handleToggleChange = () => {
    setState((prev) => ({
      ...prev,
      privateMode: !prev.privateMode,
    }));
  };

  // sync private mode state to local storage
  useEffect(() => {
    localStorage.setItem("privateMode", state.privateMode);
  }, [state.privateMode])

  // handleClose: closes the modal
  const handleClose = () =>
    setState((prev) => ({
      ...prev,
      showModal: false,
    }));

  // Get user data from localStorage
  const getUserData = () => {
    try {
      const userData = localStorage.getItem('userData');
      return userData ? JSON.parse(userData) : null;
    } catch (error) {
      console.error('Error parsing user data:', error);
      return null;
    }
  };

  // Load favorite units from localStorage
  const getFavoriteUnits = () => {
    try {
      const fav = localStorage.getItem('favoriteUnits');
      return fav ? JSON.parse(fav) : [];
    } catch {
      return [];
    }
  };

  // Load form data from localStorage (if you want to persist it, or keep in state)
  // For now, use the form state from earlier steps

  const getCategoryList = async () => {
    try {
      const response = await commonService({
        apiEndPoint: BROKER_ENDPOINT.getListCategory,
      });
      setState({
        ...state,
        isLoading: false,
        lists: response?.data?.data ?? [],
      });
    } catch (error) {
      setState({ ...state, isLoading: false });
    }
  };

  const handleSocketCommand = (item) => {

    const primarySocketObject = {
      hardware_id: item?.hardware_id,
      broker_id: item?.broker_id,
      sub_sub_category_id: item?.sub_sub_category_id,
      'cross_fade': true,
      type: "gallery_image",
      image_id: item?.primary_media_id,
      image_url: item?.primary_media,
    }

    const secondarySocketObject = {
      hardware_id: item?.secondary_player,
      broker_id: item?.broker_id,
      sub_sub_category_id: item?.sub_sub_category_id,
      'cross_fade': true,
      type: "gallery_image",
      image_id: item?.secondary_media_id,
      image_url: item?.secondary_media,
    }
    if (item?.primary_media) {
      console.log("primarySocketObject", primarySocketObject);
      socketEventManager.sendCommand(item?.hardware_id, primarySocketObject);
    }
    if (item?.secondary_media) {
      console.log("secondarySocketObject", secondarySocketObject);
      socketEventManager.sendCommand(item?.secondary_player, secondarySocketObject);
    }

  }
  const handleClearCache = () => {
    // Persistor?.purge?.();
    window.location.reload();
  };
  const handleLogout = async () => {
    try {
      // Call logout API
      await commonService({
        apiEndPoint: BROKER_ENDPOINT.postLogoutBroker,
        toastType: { success: true, error: true },
        toastMessage: { success: "Logged out successfully", error: "Logout failed" },
      });
    } catch (error) {
      // Even if API call fails, we should still logout locally
      console.error("Logout API error:", error);
    } finally {
      // Clear local storage
      localStorage.removeItem('authToken');
      localStorage.removeItem('userData');
      localStorage.removeItem('showingFormData');
      localStorage.removeItem('favoriteUnits');
      
      // Disconnect socket
      socketEventManager.disconnect();
      
      // Navigate to login page
      navigate('/');
    }
  };


  const getSavedFormData = () => {
    try {
      const saved = localStorage.getItem('showingFormData');
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  };

  // Handle Start/End Showing button click
  const openFormModal = () => {
    setApiStatus({ success: null, message: "" });

    if (showing) {
      const saved = getSavedFormData();
      if (saved) setForm(saved);
    } else {
      localStorage.removeItem('showingFormData');
      localStorage.removeItem('favoriteUnits');
      setForm({ firstName: "", lastName: "", email: "", phone: "", notes: "" });
    }
    setShowFormModal(true);
  };

  
  
  // Handle form input change
  const handleFormChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setFormError({ ...formError, [e.target.name]: "" }); // Clear specific error on input change
  };

  // Validation function
  const validateForm = () => {
    const errors = {};
    if (!form.firstName.trim()) {
      errors.firstName = "First name is required.";
    } else if (!/^[A-Za-z ]+$/.test(form.firstName.trim())) {
      errors.firstName = "First name must contain only letters.";
    }

    if (!form.lastName.trim()) {
      errors.lastName = "Last name is required.";
    } else if (!/^[A-Za-z ]+$/.test(form.lastName.trim())) {
      errors.lastName = "Last name must contain only letters.";
    }

    if (!form.email.trim()) {
      errors.email = "Email is required.";
    } else if (!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(form.email.trim())) {
      errors.email = "Enter a valid email address.";
    }

    if (!form.phone.trim()) {
      errors.phone = "Phone number is required.";
    } else if (!/^[0-9]{10,15}$/.test(form.phone.trim())) {
      errors.phone = "Enter a valid phone number (10-15 digits).";
    }

    if (!form.notes.trim()) {
      errors.notes = "Notes are required.";
    }
    return errors;
  };

  // Unified form submit handler for both start and end showing
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForm();
    setFormError(errors);
    if (Object.keys(errors).length > 0) return;
    setIsSubmitting(true);
    setApiStatus({ success: null, message: "" });
    
    try {
      if (!showing) {
        // Start Showing: save form, set showing
        localStorage.setItem("showingFormData", JSON.stringify(form));
        setShowFormModal(false);
        setIsSubmitting(false);
        setShowing(true);
      } else {
        // End Showing: update form, call API, clear all
        localStorage.setItem("showingFormData", JSON.stringify(form));
        
        const favoriteUnits = getFavoriteUnits();
        const properties = favoriteUnits.join(",");
        let brokerId = 0;
        const userData = getUserData();
        if (userData && userData.id) brokerId = userData.id;
        await commonService({
          apiEndPoint: BROKER_ENDPOINT.meeting,
          bodyData: {
            email: form.email || "",
            first_name: form.firstName || "",
            last_name: form.lastName || "",
            phone_number: form.phone || "",
            notes: form.notes || "",
            properties,
            broker_id: brokerId,
          },
          toastType: { success: false, error: false },
        });
        setApiStatus({ success: true, message: "Meeting completed and summary emailed." });
        toast.success("Meeting completed and summary emailed.");
        setForm({ firstName: "", lastName: "", email: "", phone: "", notes: "" });
        localStorage.removeItem("favoriteUnits");
        localStorage.removeItem("showingFormData");
        setShowing(false);
        setShowFormModal(false);
        setIsSubmitting(false);
      }
    } catch (error) {
      setApiStatus({ success: false, message: "Failed to complete meeting." });
      toast.error("Failed to complete meeting.");
      setIsSubmitting(false);
    }
  };

  // On mount, check if form data exists in localStorage to set showing state
  useEffect(() => {
    const savedForm = localStorage.getItem('showingFormData');
    if (savedForm) {
      setShowing(true);
    }
  }, []);

  useEffect(() => {
    getCategoryList();
  }, []);



  return (
    <div className="landingPage">
      <Container fluid className="p-0">
        <Row className="gx-0">
          <Col md={6}>
            {state.isLoading ? (
              <div className="d-flex justify-content-center align-items-center vh-100">
                <Spinner />
              </div>
            ) : !state.isLoading && state.lists?.[0]?.primary_media ? (
              <div className="landingPage_left commonLeftImg">
                <ImageElement
                  imageFor="user"
                  previewSource='landing.jpg'
                  className="w-100"
                  alt="landing"
                />
              </div>
            ) : (
              <div className="landingPage_left commonLeftImg">
                <ImageElement
                  imageFor="user"
                  previewSource="landing.jpg"
                  className="w-100"
                  alt="landing"
                />
              </div>
            )}
          </Col>
          <Col md={6}>
            <ReactPWA />
            <div className="landingPage_right d-flex flex-column justify-content-between align-items-center h-100vh">
              <div className="text-center">
                <div className="landingPage_right_logo"
                 onMouseEnter={handleMouseEnter}
                 onMouseLeave={handleMouseLeave} 
                >
                  <Link className="headLogo" to={userRouteMap.LANDING.path}>
                    <ImageElement imageFor="user" source="logo.svg" alt="logo" />
                  </Link>
                </div>
                {state.isLoading ? (
                  <div className="d-flex justify-content-center align-items-center m-auto">
                    <Spinner />
                  </div>
                ) : !state.isLoading && state.lists.length > 0 ? (
                  <div className="landingPage_right_menu text-center innerScroll px-3">
                    <>
                      <Nav className="flex-column">
                        {state.lists.map((listItem, idx) => (
                          <Link
                            onClick={() => handleSocketCommand(listItem)}
                            key={idx}
                            className="nav-link"
                            to={`${listItem?.name
                              ?.toLowerCase()
                              .split(" ")
                              .join("-")}`}
                            state={{ ...listItem }}
                          >
                            {listItem.name}
                          </Link>
                        ))}
                      </Nav>
                    </>
                  </div>
                ) : (
                  <div className="d-flex justify-content-center align-items-center">
                    No data found
                  </div>
                )}
                <div className="landingPage_right_btm w-100 text-center">
                  {localStorage.getItem('authToken') && (
                    <Button
                      variant={showing ? "secondary" : "dark"}
                      className="text-uppercase px-4 py-2 mt-2 startShowingBtn commonBack"
                      onClick={openFormModal}
                    >
                      {showing ? "END SHOWING" : "START SHOWING"}
                      <em className="icon-play" />
                    </Button>
                  )}
                  <Modal className="clientInformationModal modal-lg" show={showFormModal} onHide={() => setShowFormModal(false)} centered>
                    <Modal.Header closeButton>
                      <Modal.Title>Client Information</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form onSubmit={handleFormSubmit}>
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Group className="mb-3">
                              <Form.Control
                                type="text"
                                name="firstName"
                                value={form.firstName}
                                onChange={handleFormChange}
                                required
                                placeholder="First Name"
                              />
                              {formError.firstName && (
                                <div className="text-danger">{formError.firstName}</div>
                              )}
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            <Form.Group className="mb-3">
                              <Form.Control
                                type="text"
                                name="lastName"
                                value={form.lastName}
                                onChange={handleFormChange}
                                required
                                placeholder="Last Name"
                              />
                              {formError.lastName && (
                                <div className="text-danger">{formError.lastName}</div>
                              )}
                            </Form.Group>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Group className="mb-3">
                              <Form.Control
                                type="email"
                                name="email"
                                value={form.email}
                                onChange={handleFormChange}
                                required
                                placeholder="Email"
                              />
                              {formError.email && (
                                <div className="text-danger">{formError.email}</div>
                              )}
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            <Form.Group className="mb-3">
                              <Form.Control
                                type="text"
                                name="phone"
                                value={form.phone}
                                onChange={handleFormChange}
                                required
                                placeholder="Phone Number"
                              />
                              {formError.phone && (
                                <div className="text-danger">{formError.phone}</div>
                              )}
                            </Form.Group>
                          </div>
                        </div>
                        <Form.Group className="mb-3">
                          <Form.Label className="text-uppercase small">Notes</Form.Label>
                          <Form.Control
                            as="textarea"
                            name="notes"
                            value={form.notes}
                            onChange={handleFormChange}
                            rows={3}
                            required
                            placeholder="Notes"
                          />
                          {formError.notes && (
                            <div className="text-danger">{formError.notes}</div>
                          )}
                        </Form.Group>
                        {/* <div className="mb-3">
                          <strong>Favorite Units:</strong> {getFavoriteUnits().join(", ") || "None"}
                        </div> */}
                        {apiStatus.message && (
                          <Alert variant={apiStatus.success ? "success" : "danger"}>
                            {apiStatus.message}
                          </Alert>
                        )}                        
                        
                        <div className="d-flex justify-content-center mt-4 mb-3">
                          <Button type="submit" variant="dark" className="startShowingBtn commonBack" disabled={isSubmitting}>
                            {isSubmitting ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" /> : null}
                            {showing ? "Complete Showing and Email Summary" : "Start Showing"}
                            <em className="icon-play" />
                          </Button>
                        </div>
                      </Form>
                    </Modal.Body>
                  </Modal>
                  
                  {/* <div className="customSwitch d-flex align-items-center" /> */}
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center px-3 w-100">
              {localStorage.getItem('authToken') && (
                  <div className="text-start">
                    <p className="mb-1 text-muted">
                      {getUserData()?.name || 'User'}
                    </p>
                    <Button
                      className="commonBack text-uppercase d-block h-auto logoutBtn fs-6"
                      onClick={handleLogout}
                    >
                      Logout
                    </Button>
                  </div>
              )}
              <OverlayTrigger
                delay={{ show: 250, hide: 400 }}
                overlay={
                  <Tooltip>Please clear your cache to load the updated data.</Tooltip>
                }
              >
                <Button
                  className="commonBack text-uppercase h-auto"
                  onClick={handleClearCache}
                >
                  <img width={50} src={refreshIcon} alt="refresh-icon" />
                  <span className="d-block mt-1">Clear Cache</span>
                </Button>
              </OverlayTrigger>
            </div>
            </div>
            
          </Col>
        </Row>

        
      </Container>

      <Modal show={state.showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Private Mode</Modal.Title>
        </Modal.Header>

        {/* Show Toggle First */}
        <Modal.Body>
          <Form className="d-flex align-items-center justify-content-between">
            <Form.Label htmlFor="private-mode-switch" className="mb-0">
              Private Mode
            </Form.Label>
            <div className="scale-up">
              <Form.Check
                type="switch"
                id="private-mode-switch"
                checked={state.privateMode}
                onChange={handleToggleChange}
                label=""
              />
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Landing;
